import { render, staticRenderFns } from "./BaseButtonRefresh.vue?vue&type=template&id=1f15d260"
import script from "./BaseButtonRefresh.vue?vue&type=script&lang=js"
export * from "./BaseButtonRefresh.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonRefresh.vue?vue&type=style&index=0&id=1f15d260&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports